<template>
    <section class="list-logos-container">
        <div class="list-logos" :style="styleVars">
            <WatsonAtomDynamicText
                :text="title"
                :typography="typography.title"
                class="list-logos__title"
            />

            <div class="list-logos__partners">
                <div
                    v-for="item in items"
                    class="list-logos__partner"
                >
                    <WatsonAtomImage
                        v-if="item.logo"
                        :content="item.logo"
                        class="list-logos__partner-logo"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import WatsonAtomDynamicText from '@atoms/dynamic-text/watson-atom-dynamic-text.vue';
import WatsonAtomImage from '@atoms/image/watson-atom-image.vue';

const props = defineProps({
    content: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
    items: {
        type: Array,
        required: false,
        default: () => [],
    },
    partnerStyles: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    style: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    typography: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const styleVars = computed(() => ({
    '--background': props.style.background || 'initial',
    '--title-color': props.style.titleColor || 'initial',
}));
</script>

<style lang="scss">
@use 'watson-theme-list-logos';
</style>
